import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import UploadImage from './upload-image-input';
import { ScreenshotterItem } from '../types/screenshotter.types';
import { useCreateScreenshotterMutation } from '../endpoints/screenshotter.endpoints';
import { useUploadImageMutation } from 'src/redux/survey/survey.endpoints';

interface ScreenshotterCreateInputProps {
  className?: string;
  onCreated: () => void;
}

const ScreenshotterCreateInput: React.FC<ScreenshotterCreateInputProps> = ({
  className = '',
  onCreated,
}) => {
  const [asset, setAsset] = useState<File>();

  const [createScreenshotter, { isLoading: isCreating, data: createScreenshotterData }] = useCreateScreenshotterMutation();
  const [uploadImage, { isLoading: isUploading }] = useUploadImageMutation();

  const handleSave = async() => {
    const result = await createScreenshotter();
    const data = (result as { data: ScreenshotterItem }).data;

    if (data?.id && asset) {
      await handleUpload(data?.id);
      onCreated();
      setAsset(undefined);
    }
  };

  const handleUpload = async(uuid: string) => {
    if (asset) {
      try {
        const formData = new FormData();
        formData.append('file', asset);
        formData.append('type', 'screen_shotter');
        formData.append('uuid', uuid);

        await uploadImage({ formData: formData, uuid: uuid }).unwrap();
      } catch (error) {
        console.error('Upload Error:', error);
      }
    }
  };

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow-sm animate-in fade-in-0 slide-in-from-top-10 duration-300">
      <div className="flex items-center gap-2">
        <UploadImage
          onChange={(f) => {
            setAsset(f);
          }}
        />
      </div>
      <div className="flex items-center gap-2 mt-2 justify-end">
        <Button
          className={`hover:opacity-65 bg-gray-200 px-5`}
          variant="ghost"
          size="med"
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default ScreenshotterCreateInput;
